import styled from 'styled-components';

import { Flex } from '../Flex';

export const StyledLabel = styled(Flex)`
  transition: all 0.2s ease;
  -webkit-transition: all 0.2s ease;
`;
